import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePatch } from '../../../../../utils/AxiosUtil';
import ErrorAwareNumberField from '../../../../common/inputfields/ErrorAwareNumberField';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../../common/inputfields/NewAgainField';

class ModifyAvailableVacation extends Component {


    state = {
        selectedEmployee: { label: this.props.row.employeeName, value: this.props.row.employeeId },
        year: this.props.row.year,
        days: this.props.row.availableDays,
        notUsedDays: this.props.row.notUsedDays || '',
        addedDays: this.props.row.addedDays || '',
        errors: new Map(),
    }

    componentDidMount() {
        console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/availablevacation';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "employeeId": this.state.selectedEmployee.value,
            "year": this.state.year,
            "days": this.state.days,
            "notUsedDays": this.state.notUsedDays,
            "addedDays": this.state.addedDays,
        };
        console.log(requestObject);
        handlePatch(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            type: 'FULL_TIME'
        };
        const response = await axios.get('/api/employees', { params })
        const renamedCustomers = [];
        response.data.map((resp) =>
            renamedCustomers.push({
                label: resp.employee.name,
                value: resp.employee.privateId,
            }));
        return renamedCustomers;
    };

    handleEmployeeSelected = (e, v) => {
        this.setState({ selectedEmployee: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee || ''}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            disabled={this.state.partnerDisabled}
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="year"
                            label="Év"
                            errors={this.state.errors}
                            value={this.state.year}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="days"
                            label="Napok száma"
                            errors={this.state.errors}
                            value={this.state.days}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            name="addedDays"
                            label="Hozzáadott napok száma"
                            errors={this.state.errors}
                            value={this.state.addedDays}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            name="notUsedDays"
                            label="Nem használt napok száma"
                            errors={this.state.errors}
                            value={this.state.notUsedDays}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyAvailableVacation);
